import React, { useCallback, useState, useEffect } from 'react';
import { UIDrawerModal } from '../components/modals';
import { UITabBlock, UIPicture, UIIconBtn } from '../components/basic';
import { PopupConstruction } from '../components/popups';
import { useLang } from '../../_LangContext';
import { useNavigation } from '../../_NavigationContext';
import LocaleService from '../../services/LocaleService';
import ConstructionConfig from '../../_ConstructionConfig';
import GTM from '../../_GTM';
import { mergeClasses } from '@griffel/react';
import { MapInfoTabsTatemono, MapInfoTabsExterior, MapInfoTabsFood, ARButton } from '../mapinfo';

const ModalMapInfo = ({ isOpen, onClose, data }) =>
{
	const { lang, getText, isVoiceoverEnabled } = useLang();
	const { navigateToHomeDirect } = useNavigation();
	const [constructionModalOpen, setConstructionModalOpen] = useState(false);

	const handleHomeClick = () =>
	{
		navigateToHomeDirect();
	};

	const handleCloseConstructionModal = () =>
	{
		setConstructionModalOpen(false);
	};

	useEffect(() =>
	{
		if (data && data.id && data.type && ConstructionConfig.isConstruction(data.id, data.type) && isOpen)
		{
			setConstructionModalOpen(true);
		}
		else
		{
			setConstructionModalOpen(false);
		}
	},
	[data, isOpen]);

	const infoType = data ? data.type : 'site';
	const modalClassName = mergeClasses('info-modal', infoType + '-info');

	const handleTabChange = (index, label) =>
	{
		GTM.sendEvent('tab_change',
		{
			content_group: 'map',
			lang: lang,
			page_type: infoType,
			page_name: data?.name || '',
			index: index,
			name: label,
		}
		);
	};

	const renderARButton = useCallback(() =>
	{
		return <ARButton data={data} lang={lang} />;
	},
	[data, lang]);

	let tabs = [];

	if (data)
	{
		// Add is_construction flag from ConstructionConfig to data
		const dataWithConstruction = {
			...data,
			is_construction: (data.id && data.type) ? ConstructionConfig.isConstruction(data.id, data.type) : false
		};

		//Tatemono
		if (infoType === 'site')
		{
			tabs = MapInfoTabsTatemono({ 
				data: dataWithConstruction, 
				lang: lang, 
				renderARButton,
				getText,
				isVoiceoverEnabled
			});
		}
		//Exterior Monuments
		else if (infoType === 'exterior')
		{
			tabs = MapInfoTabsExterior({ 
				data: dataWithConstruction, 
				lang: lang,
				getText,
				isVoiceoverEnabled
			});
		}
		//Restaurant and Cafe
		else if (infoType === 'food')
		{
			tabs = MapInfoTabsFood({ 
				data: dataWithConstruction, 
				lang: lang,
				getText,
				isVoiceoverEnabled
			});
		}
	}

	return (
		<>
		<UIDrawerModal className={modalClassName} isOpen={isOpen} onClose={onClose} shouldCloseOnOverlayClick={false}>
			<div className="modal-header-bar">
				<div className="left-ui">
					<div className="modal-bar-btn back" onClick={onClose}>
						<p className="icon angle-left" />
					</div>
				</div>
				<div className="right-ui sp-only">
					<UIIconBtn id="btn-map-home" className={`btn-map-home circle no-base`} btnKey="home" iconClass="home" onClick={handleHomeClick} />
				</div>
			</div>
			{data && (
				<div className="modal-container">
					<UIIconBtn id="" className="back-btn circle size-ms b-b" btnKey="back" iconClass="angle-left" onClick={onClose} />
					<div className="modal-container-inner">
						<section className="content-header">
							<div className="right-ui">
								<UIIconBtn id="btn-map-home" className={`btn-map-home circle size-ms sp-only`} btnKey="home" iconClass="home" onClick={handleHomeClick} />
							</div>
						</section>
						<section className="image">
							<UIPicture 
								src={data.img} 
								alt={data.name || ''} 
								className="main-image" 
							/>
						</section>
						<section className="primary">
							<div className="section-container">
								<div className="block title">
									{infoType === 'site' && (
									<>
										<div className="title-name main">
											<div className="site-label" data-zone={data.zone}>
												{data.zone.toUpperCase() + data.zone_site_id}
											</div>
											<p>{data.name || ''}</p>
										</div>
										<div className="title-name sub">
											{lang === 'ja' ? 
												data.furigana || data.name : 
												LocaleService.getItemData('ja', 'buildings', data.id)?.name || data.name
											}
										</div>
									</>
									)}
									{infoType === 'exterior' && (
									<>
										<div className="title-name main">
											<div className="site-label" data-zone={data.zone}>
												{"Y" + data.id}
											</div>
											<p>{data.name || ''}</p>
										</div>
										<div className="title-name sub">
											{lang === 'ja' ? 
												data.furigana || data.name : 
												LocaleService.getItemData('ja', 'exteriors', data.id)?.name || data.name
											}
										</div>
									</>
									)}
									{infoType === 'food' && (
									<>
										<div className="title-name main">
											<p>{data.name || ''}</p>
										</div>
									</>
                                    )}
								</div>
							</div>
						</section>
						<section className="information">
							<UITabBlock
								className="site-info"
								tabs={tabs}
								onTabChange={handleTabChange}
							/>
						</section>
					</div>
				</div>
			)}
		</UIDrawerModal>
		<PopupConstruction 
			isOpen={constructionModalOpen} 
			onClose={handleCloseConstructionModal}
		/>
		</>
	);
};

export default ModalMapInfo;